export const NETWORK_FEED_TYPE = 'NETWORK_FEED_TYPE';
export const GROUP_FEED_TYPE = 'GROUP_FEED_TYPE';
export const MY_GROUPS_FEED_TYPE = 'MY_GROUPS_FEED_TYPE';
export const END_OF_FEED_TYPE = 'END_OF_FEED_TYPE';
